// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('stock.stockValueReports', {
        url: '/stockvaluereports',
        views: {
            "wideColumnView@stock": {
                templateUrl: 'main/stock/reports/stockValueReports.tpl.html',
                controller: 'ReportsController as vm'
            }
        },
        resolve: {
            locations: locationsResolver
        }
    });
}

// @ngInject
function locationsResolver(StockApiService) {
    return StockApiService.getLocations();
}

// @ngInject
function ReportsController(StockApiService, $window, locations, loadSpinnerService, ToasterService, $translate) {
    var vm = this;

    //Properties
    vm.reportParameters = {
        stockEndDate: new Date(),
        inventoryDays: 0,
        locations: []
    };
    vm.locations = locations;
    vm.selectedInventoryDays = { name: 0, value: 0 };
    vm.inventoryDayList = [];
    vm.printLanguage = 'se';
    vm.includeExternalId = false;
    vm.includeBarcode = false;
    vm.filterZeroStock = false;
    vm.groupingLevels = [
        //{ name: 'article.itemgroup', value: 'itemGroupLevel' },
        { name: 'grouping.variant1', value: 'articleVariant1Level' },
        { name: 'grouping.variant2', value: 'articleVariant1Variant2Level' }
    ];

    for (var i = 0; i < 15; i++) {
        vm.inventoryDayList.push({ name: i, value: i });
    }

    //Methods
    vm.getStockValueReport = getStockValueReport;

    activate();

    function activate() {
        vm.reportParameters.locations = angular.copy(locations);
        vm.selectedGroupingLevel = _.find(vm.groupingLevels, function(o) { return o.value === 'articleVariant1Level';});
        readSettingsFromLocalStorage();
    }

    function getStockValueReport() {
        var request = {
            stockDate: vm.reportParameters.stockEndDate,
            inventoryDays: vm.selectedInventoryDays.value,
            locationIds: _.map(vm.reportParameters.locations, 'id'),
            languageCode: vm.printLanguage,
            level: vm.selectedGroupingLevel.value,
            includeExternalId: vm.includeExternalId,
            includeBarcode: vm.includeBarcode,
            filterZeroStock: vm.filterZeroStock
        };

        loadSpinnerService.start("mainSpinner");
        saveSettingsToLocalStorage();

        StockApiService.downloadStockValueReport(request).then(function () {
            //Display CSV file
            ToasterService.showSuccess($translate.instant('analysis.reportName') + ' ' + $translate.instant('common.created'), $translate.instant('common.stock'));
        }, function (error) {
            if (error.errors) {
                vm.validationErrors = error.errors;
            }
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function saveSettingsToLocalStorage() {
        var request = {
            languageCode: vm.printLanguage,
            groupingLevel: vm.selectedGroupingLevel.value,
            includeExternalId: vm.includeExternalId,
            includeBarcode: vm.includeBarcode,
            filterZeroStock: vm.filterZeroStock
        };

        $window.localStorage.setItem('printStockValueReportSettings', JSON.stringify(request));
    }
    function readSettingsFromLocalStorage() {
        if ($window.localStorage.printStockValueReportSettings) {
            if (!isJsonString($window.localStorage.getItem('printStockValueReportSettings'))) {
                $window.localStorage.removeItem('printStockValueReportSettings');
            }

            var settingsStr = $window.localStorage.getItem('printStockValueReportSettings');
            if (settingsStr !== null) {
                var json = JSON.parse(settingsStr);
                if (json.languageCode) { vm.printLanguage = json.languageCode; }
                if (json.groupingLevel) { vm.selectedGroupingLevel = _.find(vm.groupingLevels, function(o) { return o.value === json.groupingLevel; }); }
                if (json.includeExternalId) { vm.includeExternalId = json.includeExternalId; }
                if (json.includeBarcode) { vm.includeBarcode = json.includeBarcode; }
                if (json.filterZeroStock) { vm.filterZeroStock = json.filterZeroStock; }
            }
        }
    }
    function isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
}

angular.module('stock.stockValueReports', [])
    .config(stateConfig)
    .controller('ReportsController', ReportsController);

